import { render, staticRenderFns } from "./ModalRequestTransfer.vue?vue&type=template&id=1f2f2344&scoped=true"
import script from "./ModalRequestTransfer.vue?vue&type=script&lang=js"
export * from "./ModalRequestTransfer.vue?vue&type=script&lang=js"
import style0 from "./ModalRequestTransfer.vue?vue&type=style&index=0&id=1f2f2344&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f2f2344",
  null
  
)

export default component.exports